<template>
  <v-dialog v-model="addDialog" class="the-app-dialogs" persistent max-width="600px">
    <v-card>
      <form @submit.prevent="validateBeforeSubmit($event)">
        <v-layout row class="no-select" style="background-color:#09132f">
          <h3 id="dialog-title" class="text-uppercase px-3 pt-3" style="text-xs-center letter-spacing:2px">
            <v-layout align-center>
              <v-icon light x-large class="rgba(0,0,0,0.3)--text pb-1">attach_money</v-icon>
              <span class="px-3">{{ $t('Add New Cashier') }}</span>
            </v-layout>
          </h3>
          <v-spacer />
          <v-card-actions>
            <v-btn fab icon dark @click="$emit('hidemodal')">
              <v-icon>close</v-icon>
            </v-btn>
          </v-card-actions>
        </v-layout>

        <v-card-title class="grey lighten-3">
          <v-layout row wrap>
            <v-flex pa-2 xs11 :class="{ xs12: !hasPermissions(['users_store']) }">
              <v-autocomplete
                id="main-cashier-focus-me"
                v-model="form.user_id_fk"
                :items="staffsList"
                :label="`${$t('Staff')} *`"
                box
                hide-details
                :error="errors.has('Staff')"
                background-color="white"
                v-validate="'required'"
                data-vv-name="Staff"
                :menu-props="{ transition: 'slide-y-transition' }"
              />
            </v-flex>

            <v-flex xs1 pt-2 v-if="hasPermissions(['users_store'])">
              <v-tooltip top>
                <v-btn label @click="$emit('add-staff')" slot="activator" icon fab small color="green">
                  <v-icon color="white" size="25">add</v-icon>
                </v-btn>
                <span>{{ $t('Add new staff') }}</span>
              </v-tooltip>
            </v-flex>

            <v-layout row wrap>
              <v-flex xs12 sm12 md12 class="py-1 px-2">
                <v-text-field
                  v-model="form.main_cashier_name"
                  :label="`${$t('Cashier Name / Code')} *`"
                  name="main_cashier_name"
                  hide-details
                  box
                  background-color="white"
                  :error="errors.has('main_cashier_name')"
                  v-validate="'required'"
                />
              </v-flex>

              <v-flex xs6 sm6 class="pa-2">
                <v-menu offset-y full-width :close-on-content-click="false">
                  <v-text-field
                    slot="activator"
                    :value="formatStartTime"
                    :label="$t('Start Time')"
                    prepend-inner-icon="event"
                    box
                    hide-details
                    data-vv-name="start_time"
                    background-color="white"
                    autocomplete="off"
                  />
                  <v-time-picker v-model="form.start_time" width="318" />
                </v-menu>
              </v-flex>
              <v-flex xs6 sm6 class="pa-2">
                <v-menu offset-y full-width :close-on-content-click="false">
                  <v-text-field
                    slot="activator"
                    :value="formatEndTime"
                    :label="$t('End Time')"
                    prepend-inner-icon="event"
                    box
                    hide-details
                    background-color="white"
                    data-vv-name="end_time"
                    autocomplete="off"
                  />
                  <v-time-picker v-model="form.end_time" width="318" />
                </v-menu>
              </v-flex>
            </v-layout>
          </v-layout>
        </v-card-title>
        <v-divider light />

        <v-card-actions class="grey lighten-3">
          <v-layout column>
            <v-flex xs12 class="pb-2 px-2" style="color: #444;"
              >- {{ $t('Fields marked with asterisk ( * ) are required.') }}</v-flex
            >

            <v-layout justify-end align-center pr-2 pl-2>
              <v-checkbox color="primary" v-model="keepForm" :label="$t('Keep this form to add another one.')" />

              <v-btn outline color="primary" @click="$emit('hidemodal')">{{ $t('Cancel') }}</v-btn>
              <v-btn type="submit" color="success" :loading="btnAddLoading">
                <v-icon :right="$vuetify.rtl" :left="!$vuetify.rtl">save</v-icon>
                {{ $t('Add') }}
              </v-btn>
            </v-layout>
          </v-layout>
        </v-card-actions>
      </form>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import * as helpers from '@/mixins/helperFunctions.js'

export default {
  name: 'add-component',

  props: {
    addDialog: { type: Boolean, required: true }
  },

  data() {
    return {
      dialogs: {
        addOutlet: false,
        addStaff: false
      },
      btnAddLoading: false,
      form: {
        start_time: '',
        end_time: ''
      },
      keepForm: false
    }
  },

  computed: {
    ...mapGetters({
      staffsList: 'staff/getFullOutletStaffsList'
    }),

    formatStartTime() {
      if (!this.form.start_time) {
        return ''
      }
      return helpers.formatTimeForDisplay(this.form.start_time)
    },

    formatEndTime() {
      if (!this.form.end_time) {
        return ''
      }
      return helpers.formatTimeForDisplay(this.form.end_time)
    }
  },

  watch: {
    addDialog: {
      immediate: false,
      handler() {
        if (this.addDialog) {
          this.addEscKeyListener()
          this.resetForm()
          this.keepForm = false
        }
      }
    }
  },

  methods: {
    ...mapActions({
      addMainCashier: 'mainCashiers/addMainCashier'
    }),

    hasPermissions(permissions) {
      return helpers.userHasPermissions(permissions)
    },

    addEscKeyListener() {
      document.addEventListener('keyup', e => {
        // if the 'ESC' button was pressed and this dialog is shown, hide it
        if (e.keyCode === 27 && this.addDialog) {
          this.$emit('hidemodal')
        }
      })
    },

    resetForm() {
      this.$validator.pause()
      for (let key in this.form) {
        this.form[`${key}`] = null
      }
      this.$nextTick(() => {
        this.$validator.resume()
        // default veutify autofocus only one time works so we have to handled in this way.
        // document.getElementById('main-cashier-focus-me').focus()
      })
    },

    validateBeforeSubmit(event) {
      this.$validator
        .validateAll()
        .then(() => {
          if (!this.errors.any()) {
            this.btnAddLoading = true

            let formData = new FormData(event.target)
            formData.append('user_id_fk', this.form.user_id_fk)
            formData.append('start_time', this.form.start_time || '')
            formData.append('end_time', this.form.end_time || '')

            this.addMainCashier(formData)
              .then(() => {
                this.btnAddLoading = false
                this.$emit('reset-datatable')
                if (this.keepForm) {
                  this.resetForm()
                } else {
                  this.$emit('hidemodal')
                }
              })
              .catch(() => {
                this.btnAddLoading = false
              })
          }
        })
        .catch(() => {
          this.btnAddLoading = false
        })
    }
  }
}
</script>

<style scoped />
